var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFleet(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 118,
    height: 118,
    viewBox: "0 0 118 118",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.375 69.5707L39.5792 51.1332L108.167 85.5499L73.75 102.758L7.375 69.5707Z",
    fill: "#D9D9D9"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.0288 61.4582V70.7999L19.1746 67.6041V58.5082L13.0288 61.4582Z",
    fill: "#2D3134"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.39,
    d: "M13.0288 61.4582V70.7999L19.1746 67.6041V58.5082L13.0288 61.4582Z",
    fill: "black"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M64.4085 80.8791C62.6877 79.8957 60.9668 79.8957 59.7377 80.3874L56.296 82.1082C54.821 82.5999 54.0835 84.0749 54.0835 86.0416C54.0835 89.7291 57.2793 94.3999 60.9668 96.3666C62.9335 97.3499 64.6543 97.3499 65.8835 96.8582C65.8835 96.8582 69.3252 95.1374 69.571 94.8916C70.8002 94.1541 71.2918 92.9249 71.2918 91.2041C71.2918 87.2707 68.096 82.5999 64.4085 80.8791Z",
    fill: "#2D3134"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.39,
    d: "M65.8828 96.6123C66.3745 96.3665 69.3245 94.8915 69.5703 94.8915C70.7995 94.154 71.2911 92.9248 71.2911 91.204C71.2911 89.729 70.7995 88.0081 70.062 86.5331L66.6203 88.254C67.3578 89.729 67.8495 91.4498 67.8495 92.9248C67.8495 94.6456 67.112 96.1206 65.8828 96.6123Z",
    fill: "black"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M66.1297 91.9417C66.1297 94.8917 63.9172 95.875 60.9672 94.4C58.0172 92.925 55.8047 89.4833 55.8047 86.5333C55.8047 83.5833 58.0172 82.6 60.9672 84.075C63.9172 85.55 66.1297 88.9917 66.1297 91.9417Z",
    fill: "#999999"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.15,
    d: "M61.4589 94.4C58.5089 92.925 56.2964 89.4833 56.2964 86.5333C56.2964 85.0583 56.788 84.075 57.7714 83.5833C56.5422 83.8291 55.8047 85.0583 55.8047 86.5333C55.8047 89.4833 58.0172 92.925 60.9672 94.4C62.4422 95.1375 63.6714 95.1375 64.6547 94.6458C63.6714 95.1375 62.688 94.8917 61.4589 94.4Z",
    fill: "black"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M63.6716 90.2209C63.6716 91.45 62.6882 91.9417 61.4591 91.2042C60.2299 90.4667 59.2466 89.2375 59.2466 88.0084C59.2466 86.7792 60.2299 86.2875 61.4591 87.025C62.6882 87.7625 63.6716 88.9917 63.6716 90.2209Z",
    fill: "#2D3134"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.39,
    d: "M63.6716 90.2209C63.6716 91.45 62.6882 91.9417 61.4591 91.2042C60.2299 90.4667 59.2466 89.2375 59.2466 88.0084C59.2466 86.7792 60.2299 86.2875 61.4591 87.025C62.6882 87.7625 63.6716 88.9917 63.6716 90.2209Z",
    fill: "black"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M63.1784 90.4665C63.1784 91.6957 62.1951 92.1874 60.9659 91.4499C59.7368 90.9582 58.7534 89.4832 58.7534 88.254C58.7534 87.0249 59.7368 86.5332 60.9659 87.2707C62.1951 87.7624 63.1784 89.2374 63.1784 90.4665Z",
    fill: "#2D3134"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.06,
    d: "M67.8502 92.9249C67.8502 96.6124 64.6543 98.3332 60.9668 96.3666C57.2793 94.3999 54.0835 89.7291 54.0835 86.0416C54.0835 82.3541 57.2793 80.6332 60.9668 82.5999C64.6543 84.3207 67.8502 88.9916 67.8502 92.9249Z",
    fill: "black"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M23.846 60.4749C22.1252 59.4916 20.4043 59.4916 19.1752 59.9832L15.7335 61.7041C14.5043 62.1957 13.521 63.6707 13.521 65.6374C13.521 69.3249 16.7168 73.9957 20.4043 75.9624C22.371 76.9457 24.0918 76.9457 25.321 76.4541C25.321 76.4541 28.7627 74.7332 29.0085 74.4874C30.2377 73.7499 30.7293 72.5207 30.7293 70.7999C30.7293 67.1124 27.5335 62.4416 23.846 60.4749Z",
    fill: "#2D3134"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.39,
    d: "M25.3203 76.4542C25.812 76.2083 28.762 74.7333 29.0078 74.7333C30.237 73.9958 30.7286 72.7667 30.7286 71.0458C30.7286 69.5708 30.237 67.85 29.4995 66.375L26.0578 68.0958C26.7953 69.5708 27.287 71.2917 27.287 72.7667C27.287 74.4875 26.5495 75.7167 25.3203 76.4542Z",
    fill: "black"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M25.5672 71.7833C25.5672 74.7333 23.3547 75.7166 20.4047 74.2416C17.4547 72.7666 15.2422 69.3249 15.2422 66.3749C15.2422 63.4249 17.4547 62.4416 20.4047 63.9166C23.3547 65.3916 25.5672 68.8333 25.5672 71.7833Z",
    fill: "#999999"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.15,
    d: "M20.8964 73.9959C17.9464 72.5209 15.7339 69.0793 15.7339 66.1293C15.7339 64.6543 16.2255 63.6709 17.2089 63.1793C15.9797 63.4251 15.2422 64.6543 15.2422 66.1293C15.2422 69.0793 17.4547 72.5209 20.4047 73.9959C21.8797 74.7334 23.1089 74.7334 24.0922 74.2418C23.1089 74.7334 22.1255 74.7334 20.8964 73.9959Z",
    fill: "black"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M23.1091 70.0624C23.1091 71.2916 22.1257 71.7833 20.8966 71.0458C19.6674 70.5541 18.6841 69.0791 18.6841 67.8499C18.6841 66.6208 19.6674 66.1291 20.8966 66.8666C22.1257 67.3583 23.1091 68.8333 23.1091 70.0624Z",
    fill: "#2D3134"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.39,
    d: "M23.1091 70.0624C23.1091 71.2916 22.1257 71.7833 20.8966 71.0458C19.6674 70.5541 18.6841 69.0791 18.6841 67.8499C18.6841 66.6208 19.6674 66.1291 20.8966 66.8666C22.1257 67.3583 23.1091 68.8333 23.1091 70.0624Z",
    fill: "black"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M22.6159 70.0624C22.6159 71.2916 21.6326 71.7833 20.4034 71.0458C19.1743 70.3083 18.1909 69.0791 18.1909 67.8499C18.1909 66.6208 19.1743 66.1291 20.4034 66.8666C21.6326 67.6041 22.6159 69.0791 22.6159 70.0624Z",
    fill: "#2D3134"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.06,
    d: "M27.2877 72.5208C27.2877 76.2083 24.0918 77.9291 20.4043 75.9624C16.7168 73.9958 13.521 69.3249 13.521 65.6374C13.521 61.9499 16.7168 60.2291 20.4043 62.1958C24.0918 64.1624 27.2877 68.8333 27.2877 72.5208Z",
    fill: "black"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M41.7917 2.45831L7.375 19.6666V57.2791L51.625 79.4041L86.0417 61.4583V24.5833L41.7917 2.45831Z",
    fill: "#FFB600"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M7.375 54.0833V59L51.625 81.125V76.2083L7.375 54.0833Z",
    fill: "#2D3134"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M86.0417 59V63.9167L51.625 81.125V76.2083L86.0417 59Z",
    fill: "#2D3134"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.06,
    d: "M7.375 19.6667V59L51.625 81.125V41.7917L7.375 19.6667Z",
    fill: "black"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.39,
    d: "M86.0417 24.5833V63.9166L51.625 81.125V41.7916L86.0417 24.5833Z",
    fill: "black"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M103.25 44.25L88.5002 36.875L54.0835 54.0833V81.8625C54.0835 82.6 55.0668 83.0917 55.8043 82.6C58.7543 80.1417 63.9168 81.8625 67.6043 86.2875C69.8168 88.9917 70.8002 91.9417 70.8002 94.4L73.7502 95.875L108.167 78.6667V59L103.25 44.25Z",
    fill: "#E5E5E5"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M74.7331 74.9792L70.554 62.6875C70.3081 62.1959 70.554 61.95 71.0456 61.7042L101.775 46.4625C102.266 46.2167 102.758 46.4625 103.004 46.9542L106.937 58.5084C107.183 59 106.937 59.2459 106.446 59.4917L75.9623 75.4709C75.4706 75.7167 74.7331 75.4709 74.7331 74.9792Z",
    fill: "#3399CC"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.15,
    d: "M80.3877 57.0334L101.529 46.4625C102.021 46.2167 102.513 46.4625 102.759 46.9542L106.446 57.7709L80.3877 57.0334Z",
    fill: "black"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M106.692 58.5083L106.446 57.7708C106.446 58.2625 106.446 58.5083 105.955 58.7541L75.4714 74.7333C74.9797 74.9791 74.488 74.7333 74.2422 74.2416L74.488 74.9791C74.7339 75.4708 75.2255 75.7167 75.7172 75.4708L106.201 59.4916C106.692 59.2458 106.938 59 106.692 58.5083Z",
    fill: "#2D3134"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M82.354 73.75L99.5623 65.1458V79.4041L82.354 88.0083V73.75Z",
    fill: "white"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M83.5835 86.0416L98.3335 78.6666V67.1124L83.5835 74.4874V86.0416Z",
    fill: "#2D3134"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M108.167 78.6667V73.75L73.75 90.9583V95.875L108.167 78.6667Z",
    fill: "#2D3134"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M68.8335 93.4167L73.7502 95.875V90.9583L68.8335 88.5V93.4167Z",
    fill: "#2D3134"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M83.5835 86.0417V88.5L98.3335 81.125V78.6667L83.5835 86.0417Z",
    fill: "white"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M67.6036 62.1959L58.2619 57.525C58.0161 57.2792 57.5244 57.525 57.5244 58.0167V65.3917C57.5244 65.8834 57.7703 66.375 58.2619 66.375L61.4577 68.0959C61.7036 68.3417 61.9494 68.3417 62.1952 68.5875L65.3911 72.5209C65.3911 72.5209 65.3911 72.5209 65.6369 72.5209L71.0452 75.225C71.2911 75.4709 71.7828 74.9792 71.5369 74.7334L67.3577 62.4417C67.8494 62.4417 67.8494 62.1959 67.6036 62.1959Z",
    fill: "#3399CC"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.15,
    d: "M72.0293 74.4875L67.1127 72.0292C67.1127 72.0292 67.1127 72.0292 66.8668 72.0292L63.671 68.0959C63.4252 67.85 63.1793 67.6042 62.9335 67.6042L59.7377 65.8834C59.246 65.6375 59.0002 65.3917 59.0002 64.9V57.7709L58.5085 57.525C58.2627 57.2792 57.771 57.525 57.771 58.0167V65.3917C57.771 65.8834 58.0168 66.375 58.5085 66.375L61.7043 68.0959C61.9502 68.3417 62.196 68.3417 62.4418 68.5875L65.6377 72.5209C65.6377 72.5209 65.6377 72.5209 65.8835 72.5209L71.2918 75.225C71.7835 75.4709 72.0293 75.225 72.0293 74.4875Z",
    fill: "black"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M73.7502 86.0416V90.9583L72.521 90.4666V85.5499L73.7502 86.0416Z",
    fill: "#FFCC00"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M83.5835 76.2083V76.9458L98.3335 69.5708V68.8333L83.5835 76.2083Z",
    fill: "#E5E5E5"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M83.5835 78.6667V79.4042L98.3335 72.0292V71.2917L83.5835 78.6667Z",
    fill: "#E5E5E5"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M83.5835 81.125V81.8625L98.3335 74.4875V73.75L83.5835 81.125Z",
    fill: "#E5E5E5"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M83.5835 83.5833V84.3208L98.3335 76.9458V76.2083L83.5835 83.5833Z",
    fill: "#E5E5E5"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M57.771 69.5707V70.7999L60.2293 72.0291V70.7999L57.771 69.5707Z",
    fill: "#2D3134"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M60.2293 72.5208L57.771 71.2916V70.7999L60.2293 72.0291V72.5208Z",
    fill: "white"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M92.1879 58.7543C91.942 58.5084 91.6962 58.5084 91.4504 58.7543L82.1087 69.3251C81.8629 69.5709 81.8629 69.8168 82.1087 70.0626C82.3545 70.3084 82.6004 70.3084 82.8462 70.0626L85.3045 67.1126V69.5709H86.042V66.3751L92.1879 59.2459C92.4337 59.2459 92.4337 58.7543 92.1879 58.7543Z",
    fill: "#2D3134"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M101.037 53.8376C100.791 53.5917 100.545 53.5917 100.299 53.8376L90.9578 64.4084C90.712 64.6542 90.712 64.9001 90.9578 65.1459C91.2036 65.3917 91.4495 65.3917 91.6953 65.1459L93.9078 62.6876V65.3917H94.6453V61.9501L101.037 54.5751C101.283 54.3292 101.283 54.0834 101.037 53.8376Z",
    fill: "#2D3134"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M103.25 76.2083L108.167 73.75V68.8333L105.708 70.0625C104.233 70.8 103.25 72.275 103.25 73.9958V76.2083Z",
    fill: "white"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M104.17 71.8964C103.484 72.7389 103.355 73.7692 103.882 74.1978C104.408 74.6263 105.391 74.2908 106.077 73.4484C106.762 72.606 106.892 71.5756 106.365 71.1471C105.839 70.7185 104.856 71.054 104.17 71.8964Z",
    fill: "#2D3134"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M105.399 71.8964C104.713 72.7389 104.584 73.7692 105.111 74.1978C105.637 74.6263 106.62 74.2908 107.306 73.4484C107.992 72.606 108.121 71.5756 107.594 71.1471C107.068 70.7185 106.085 71.054 105.399 71.8964Z",
    fill: "#2D3134"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M103.25 76.2083L108.167 73.75V68.8333L103.25 76.2083Z",
    fill: "white"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M73.75 90.9583L78.6667 88.5V86.2875C78.6667 85.0583 77.4375 84.3208 76.2083 84.8125L73.75 86.0417V90.9583Z",
    fill: "white"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M75.8991 86.645C75.2134 87.4874 75.0844 88.5177 75.6109 88.9463C76.1374 89.3748 77.1201 89.0393 77.8058 88.1969C78.4915 87.3545 78.6205 86.3242 78.094 85.8956C77.5675 85.467 76.5848 85.8025 75.8991 86.645Z",
    fill: "#2D3134"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M74.6701 86.645C73.9844 87.4874 73.8554 88.5177 74.3819 88.9463C74.9084 89.3748 75.8911 89.0393 76.5768 88.1969C77.2625 87.3545 77.3915 86.3242 76.865 85.8956C76.3385 85.467 75.3558 85.8025 74.6701 86.645Z",
    fill: "#2D3134"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M73.75 90.9584L78.6667 88.5L73.75 86.0417V90.9584Z",
    fill: "white"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.06,
    d: "M68.8335 61.4583L54.0835 54.0833V81.8625C54.0835 82.6 55.0668 83.0916 55.8043 82.6C58.7543 80.1416 63.9168 81.8625 67.6043 86.2875C68.3418 87.025 68.8335 87.7625 69.0793 88.7458L68.8335 88.5V93.4166L73.7502 95.875V90.9583V76.2083L68.8335 61.4583Z",
    fill: "black"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.39,
    d: "M103.25 44.25L68.8335 61.4583L73.7502 76.2083V95.875L108.167 78.6667V59L103.25 44.25Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFleet);
export default __webpack_public_path__ + "static/media/fleet.a2aacb18c591079711dddd253c11a683.svg";
export { ForwardRef as ReactComponent };